"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["element", "children", "tel", "sms", "facetime", "email", "href", "headers", "obfuscate", "obfuscateChildren", "linkText", "style", "onClick"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function Obfuscate(props) {
  var element = props.element,
    children = props.children,
    tel = props.tel,
    sms = props.sms,
    facetime = props.facetime,
    email = props.email,
    href = props.href,
    headers = props.headers,
    obfuscate = props.obfuscate,
    obfuscateChildren = props.obfuscateChildren,
    linkText = props.linkText,
    style = props.style,
    onClick = props.onClick,
    others = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    humanInteraction = _useState2[0],
    setHumanInteraction = _useState2[1];
  var linkProps = children || tel || sms || facetime || email || href;
  var Component = element;
  var generateLink = function generateLink() {
    var link;

    // Combine email header parameters for use with email
    var combineHeaders = function combineHeaders(params) {
      return Object.keys(params).map(function (key) {
        return "".concat(key, "=").concat(encodeURIComponent(params[key]));
      }).join('&');
    };
    if (email) {
      link = "mailto:".concat(email);
      if (headers) {
        link += "?".concat(combineHeaders(headers));
      }
    } else if (tel) {
      link = "tel:".concat(tel);
    } else if (sms) {
      link = "sms:".concat(sms);
    } else if (facetime) {
      link = "facetime:".concat(facetime);
    } else if (href) {
      link = href;
    } else if ((0, _typeof2["default"])(children) !== 'object') {
      link = children;
    } else {
      return '';
    }
    return link;
  };
  var handleClick = function handleClick() {
    // Allow instantiator to provide an onClick method to be called
    // before we change location (e.g. for analytics tracking)
    if (onClick && typeof onClick === 'function') {
      onClick();
    }

    // If focused or hovered, this js will be skipped with preference for html
    if (humanInteraction === false) {
      window.location.href = generateLink({
        email: email,
        headers: headers,
        tel: tel,
        sms: sms,
        facetime: facetime,
        href: href,
        children: children
      });
    }
  };
  var reverse = function reverse(content) {
    return typeof content !== 'undefined' && content.split('').reverse().join('').replace('(', ')').replace(')', '(');
  };
  var obfuscatedStyle = _objectSpread(_objectSpread({}, style), {}, {
    unicodeBidi: 'bidi-override',
    direction: humanInteraction === true || obfuscate === false || obfuscateChildren === false ? 'ltr' : 'rtl'
  });
  var renderedLink = humanInteraction === true || obfuscate === false || (0, _typeof2["default"])(children) === 'object' || obfuscateChildren === false // Allow child elements
  ? linkProps : reverse(linkProps);
  var clickProps = Component === 'a' ? {
    href: humanInteraction === true || obfuscate === false ? generateLink() : linkText || 'obfuscated',
    onClick: handleClick
  } : {};
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
    onFocus: function onFocus() {
      return setHumanInteraction(true);
    },
    onMouseOver: function onMouseOver() {
      return setHumanInteraction(true);
    },
    onContextMenu: function onContextMenu() {
      return setHumanInteraction(true);
    }
  }, others, clickProps, {
    style: obfuscatedStyle
  }), renderedLink);
}
Obfuscate.propTypes = {
  element: _propTypes["default"].string,
  children: _propTypes["default"].node,
  tel: _propTypes["default"].string,
  sms: _propTypes["default"].string,
  facetime: _propTypes["default"].string,
  email: _propTypes["default"].string,
  href: _propTypes["default"].string,
  headers: _propTypes["default"].shape({}),
  obfuscate: _propTypes["default"].bool,
  obfuscateChildren: _propTypes["default"].bool,
  linkText: _propTypes["default"].string,
  style: _propTypes["default"].shape({}),
  onClick: _propTypes["default"].func
};
Obfuscate.defaultProps = {
  element: 'a',
  children: undefined,
  tel: undefined,
  sms: undefined,
  facetime: undefined,
  email: undefined,
  href: undefined,
  headers: undefined,
  obfuscate: undefined,
  obfuscateChildren: undefined,
  linkText: undefined,
  style: {},
  onClick: undefined
};
var _default = Obfuscate;
exports["default"] = _default;